import React, { Component } from "react";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class FooterComponent extends Component {
  render() {
    const year = new Date().getFullYear();
    const services = [
      { label: "เติมเกม UID", href: "/game-uid" },
      { label: "เติมเกม ID-PASS", href: "/topup-id-pass" },
      { label: "บัตรเติมเกม", href: "/card-topup" },
      { label: "เติมเงินมือถือ", href: "/payment-mobile" },
    ];
    const company = [
      { label: "เข้าสู่ระบบ", href: "/login" },
      { label: "สมัครสมาชิก", href: "/register" },
      { label: "นโยบายความเป็นส่วนตัว", href: "/policy-privacy" },
    ];

    return (
      <footer className="site-footer">
        <div className="container">
          <div className="row g-4">
            {/* Brand + disclaimer */}
            <div className="col-12 col-lg-4">
              <div className="site-footer__brand">Lvup Topup</div>
              <p className="site-footer__about">
                บริการเติมเกมออนไลน์ เติมเกมมือถือ และบัตรเติมเงิน ตลอด 24 ชั่วโมง
                รวดเร็ว ปลอดภัย พร้อมดีลคุ้มค่าในทุกช่วงเวลา
              </p>
              <p className="site-footer__note">
                * Lvup Topup เป็นผู้ให้บริการตัวแทนจำหน่ายเท่านั้น โปรดระวังมิจฉาชีพ
                แอบอ้างเป็นเจ้าหน้าที่ ทางเราไม่มีนโยบายขอข้อมูลส่วนตัวหรือรหัสผ่าน
              </p>
            </div>

            {/* Services */}
            <div className="col-6 col-lg-2">
              <h6 className="site-footer__heading">บริการ</h6>
              <ul className="site-footer__list">
                {services.map((s) => (
                  <li key={s.href}>
                    <a href={s.href}>{s.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company / legal */}
            <div className="col-6 col-lg-2">
              <h6 className="site-footer__heading">บริษัท</h6>
              <ul className="site-footer__list">
                {company.map((c) => (
                  <li key={c.href}>
                    <a href={c.href}>{c.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact + social */}
            <div className="col-12 col-lg-4">
              <h6 className="site-footer__heading">ติดต่อเรา</h6>
              <ul className="site-footer__list site-footer__list--contact">
                <li>
                  <a href="mailto:lvtopup@gmail.com">อีเมล : lvtopup@gmail.com</a>
                </li>
                <li>
                  <a href="tel:092-981-1596">โทร : 092-981-1596</a>
                </li>
                <li>เปิดบริการทุกวัน ตลอด 24 ชั่วโมง</li>
              </ul>
              <div className="site-footer__social">
                <a href="mailto:lvtopup@gmail.com" className="site-footer__social-btn" title="Email" aria-label="Email">✉</a>
                <a href="tel:092-981-1596" className="site-footer__social-btn" title="Phone" aria-label="Phone">☎</a>
                <a href="/" className="site-footer__social-btn" title="Line" aria-label="Line">L</a>
                <a href="/" className="site-footer__social-btn" title="Facebook" aria-label="Facebook">f</a>
              </div>
            </div>
          </div>

          <div className="site-footer__bottom">
            <span>© {year} Lvup Topup. สงวนลิขสิทธิ์.</span>
            <div className="site-footer__bottom-links">
              <a href="/policy-privacy">นโยบายความเป็นส่วนตัว</a>
              <a href="mailto:lvtopup@gmail.com">ติดต่อ</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
